export const ULTRASONIC_REQUIRED = [
	"ept 301",
	"elt 303",
	"faro",
	"flicker translucent",
	"wave",
];

export const HAVE_SET = [
	"apex opaque",
	"apex reflect",
	"apex view",
	"astra opaque",
	"astra privacy",
	"basket opaque",
	"basket privacy",
	"cs 100",
	"cs 101",
	"cs 103",
	"cs 105",
	"cs 110",
	"denim opaque",
	"denim privacy",
	"flicker opaque",
	"flicker translucent",
	"hs 500 fr",
	"hs 501",
	"hs 501 fr",
	"jute opaque",
	"jute privacy",
	"lattice opaque",
	"lattice translucent",
	"lima opaque",
	"lima translucent",
	"mist",
	"mykonos opaque",
	"mykonos privacy",
	"nano 55",
	"nano 60",
	"nano 65",
	"nano 70",
	"natte 10%",
	"natte 3%",
	"natte 5%",
	"peru opaque",
	"peru translucent",
	"prata opaque",
	"prata privacy",
	"reed",
	"rustica opaque",
	"rustica privacy",
	"satin opaque",
	"satin privacy",
	"structura",
	"structura opaque",
	"textilene 80",
	"textilene 90",
	"textilene nano 95",
	"textilene nano 97",
	"textilene nano 99",
	"wisp",
	"wisp opaque",
	"wool opaque",
	"wool privacy",
];

export const SOUND_ABSORPTION = ["ept 301", "ect 302", "ect 302"];
export const REFLECTIVE_BACKING = ["rs 403 reflect"];
export const EXCLUDED_SERIES = [
	"csr 103 reflect",
	"ecoscreen",
	"vinyl wideshade iv",
	"cobblestone",
	"safari",
	"midnight",
	"natural",
];

export const DISCONTINUED_SKU = [
	"F-D-APEXD-BGE-94",
	"F-D-FLK-BRKO-94",
	"F-D-LAT-LIN-108",
	"F-D-LAT-LNNO-108",
	"F-ELT-303-26-94",
	"F-ELT-303-7-94",
	"F-EPT-301-24-98",
	"F-EPT-301-82-98",
	"F-EPT-301-83-98",
	"F-EZ-900-6-118",
	"F-V2-MAT-BGE-72",
	"F-IN-GSS-BLU-110",
	"F-IN-GSS-CFF-110",
	"F-IN-GSS-CHC-110",
	"F-IN-MDS-BLK-110",
	"F-IN-MDS-BGE-110",
	"F-IN-VNT-CSM-110",
];
